import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import Button from "../../Common/FormElements/Button/Button";
import { useDispatch } from "react-redux";
import { closeCenteredModal } from "../../../REDUX/actions/centeredModal";
import { useTranslation } from "react-i18next";
const ExtraFields = ({ addAnExtraField }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
  const SubmitAddExtraField = () => {
    const { inputName, valueName } = formData;
    if (inputName && valueName) {
      const newExtraField = { inputName, valueName };
      addAnExtraField(newExtraField);
      setFormData({});
      dispatch(closeCenteredModal());
    }
  };

  return (
    <div>
      <Row>
        <Col lg={6} className="mb-3 d-flex flex-column gap-2">
          <span className="text-softBlack normalf16">{t("Field name")}</span>
          <TextInput
            className={"w100"}
            type="string"
            name="inputName"
            value={formData.inputName}
            placeholder={t("Field name")}
            callback={handleChange}
          />
        </Col>
        <Col lg={6} className="mb-3 d-flex flex-column gap-2">
          <span className="text-softBlack normalf16">{t("Value")}</span>
          <TextInput
            className={"w100"}
            type="string"
            name="valueName"
            value={formData.valueName}
            placeholder={t("Value")}
            callback={handleChange}
          />
        </Col>
        <Button onClick={SubmitAddExtraField}>{t("Add")}</Button>
      </Row>
    </div>
  );
};

export default ExtraFields;
